import React from 'react'
import './Product.css'
import { useStateValue } from './StateProvider'

import StarIcon from '@mui/icons-material/Star';

function Product({ id, title, image, price, rating }) {
    let dollarUSLocale = Intl.NumberFormat('en-US');
    const [{basket}, dispatch] = useStateValue();
// console.log('this is the bascket',basket);

    const addToBascket = () => {
        // console.log('Adding to bascket');
        
        //dispatch the item into the data layer
        dispatch({
            type:'ADD_TO_BASKET',
            item:{
                id:id,
                title:title,
                image:image,
                price:price,
                rating:rating,
            }
        })

    }
    return (
        <div className="product" id={id}>
            <div className="product_info">
                <p>{title}</p>
                <p className="product_price">
                    <small>Rs.</small>
                    <strong>{dollarUSLocale.format(price)}</strong>
                </p>
                <div className="product_rating">
                    {Array(rating).fill().map((_, i) => (
                        <p><StarIcon /></p>
                    ))}
                </div>
            </div>
            <img src={image} alt="" />
            <button onClick={addToBascket} >Add to Basket</button>
        </div>
    )
}

export default Product
